import { frontendURL } from '../../../helper/URLHelper';

const SettingsWrapper = () => import('../settings/SettingsWrapper.vue');
const IungoLogs = () => import('./Logs.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/iungo/logs'),
    component: SettingsWrapper,
    children: [
      {
        path: '',
        name: 'iungo_logs',
        meta: {
          permissions: ['administrator'],
        },
        component: IungoLogs,
      },
    ],
  },
];
